import React, { useEffect, useState } from "react";
import { get } from "../../../utils/api";
import MultiColumns from "./MultiColumns";
import { Typography } from "@mui/material";

const PageBreak = () => <div className="page-break" />;

const Governance = ({ isEditing }) => {
  const [sections, setSections] = useState([]);

  const [data, setData] = useState({
    boardIndependance: null,
    basicDetails: null,
    contactDetails: null,
    locationDetails: null,
    financialInfo: null,
  });

  useEffect(() => {
    const fetchAllData = async () => {
      try {
        const results = await Promise.allSettled([
          get(`/governance/Board-composition`),
          get(`/governance/excutive-compensation`),
          get(`/governance/ethic-compensation`),
          get(`/governance/risk-mangement`),
          get(`/governance/stakeholder-engagement`),
          get(`/governance/cybersecurity-dataprivacy`),
        ]);

        const safeData = (result) =>
          result.status === "fulfilled" ? result.value?.data || {} : {};

        const [
          boardIndependances,
          excutiveCompensationRes,
          ethicsRes,
          riskMangementRes,
          stakeholderRes,
          cybersecurityRes,
        ] = results;

        const newData = {
          boardIndependance: safeData(boardIndependances),
          excutiveCompensation: safeData(excutiveCompensationRes),
          ethics: safeData(ethicsRes),
          riskMangement: safeData(riskMangementRes),
          stakeholder: safeData(stakeholderRes),
          cybersecurity: safeData(cybersecurityRes),
        };

        setData(newData);
      } catch (error) {
        console.error("Unexpected error in fetchAllData:", error);
      }
    };

    fetchAllData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const sectionConfigs = [
          {
            title: "BOARD COMPOSITION & EFFECTIVENESS",
            data: data?.boardIndependance,
            url: "/governance/Board-composition",
            questionary: [
              {
                key: "boardIndependance",
                question: "Board Independence",
                gridSize: { xs: 12 },
              },
              {
                mainheading: "Board Diversity",
              },
              {
                key: "boardDiversity.Male",
                question: "male",
                gridSize: { xs: 12, md: 6 },
              },
              {
                key: "boardDiversity.Female",
                question: "Female",
                gridSize: { xs: 12, md: 6 },
              },
              {
                key: "boardDiversity.MinAge",
                question: "Minimum Age",
                gridSize: { xs: 12, md: 6 },
              },
              {
                key: "boardDiversity.MaxAge",
                question: "Maximum Age",
                gridSize: { xs: 12, md: 6 },
              },
              {
                key: "boardDiversity.MinYears",
                question: "Min. years of experience",
                gridSize: { xs: 12, md: 6 },
              },
              {
                key: "boardDiversity.MaxYears",
                question: "Max. years of experience",
                gridSize: { xs: 12, md: 6 },
              },

              {
                key: "boardMeetingAttendance",
                unit: "%",
                question: "Board Meeting Attendance",
              },
              {
                mainheading: "Board Committees",
              },
              {
                key: "boardCommittees.Total",
                question: "Total number of committees",
              },
              {
                key: "boardCommittees.Type",
                question: "Type of committee",
                gridSize: { xs: 12, md: 6 },
              },
              {
                key: "boardCommittees.Range",
                unit: "%",
                question: "Attendance Rate",
                gridSize: { xs: 12, md: 6 },
              },
            ],
          },
          {
            title: "EXECUTIVE COMPENSATION",
            data: data?.excutiveCompensation,
            url: "/governance/executive-compensation",
            questionary: [
              {
                mainheading: "CEO Pay Ratio",
              },

              {
                key: "ceoPayRatio.ceo_pay",
                question: "CEO Pay",
                unit: "%",
                gridSize: { xs: 12, md: 6 },
              },
              {
                key: "ceoPayRatio.median_emp_pay",
                question: "Median Employee Pay",
                unit: "%",
                gridSize: { xs: 12, md: 6 },
              },
              {
                key: "linkageExecutiveCompensationEsgPerformance.brief",
                question:
                  "Linkage of Executive Compensation to ESG Performance ",
              },
            ],
          },
          {
            title: "ETHICS & COMPLIANCE",
            data: data?.ethics,
            url: "/governance/ethics",
            questionary: [
              {
                mainheading: "Code of Conduct Violations",
              },
              {
                question: "Types of Violation",
                key: "codeConductViolations.type_violation",
                gridSize: { xs: 12, md: 6 },
              },
              {
                question: "Number of Incidence",
                key: "codeConductViolations.number_incidence",
                gridSize: { xs: 12, md: 6 },
              },

              {
                mainheading: "Anti Corruption Measure",
              },
              {
                question: "Policy",
                key: "antiCorruptionMeasures.policy",
                gridSize: { xs: 12, md: 6 },
              },
              {
                question: "Min. years of policy experience ",
                key: "antiCorruptionMeasures.minyears_experience_policy",
                gridSize: { xs: 12, md: 6 },
              },
              {
                question: "Training Program",
                key: "antiCorruptionMeasures.training_program",
                gridSize: { xs: 12, md: 6 },
              },
              {
                question: "Min. years of policy experience ",
                key: "antiCorruptionMeasures.minyears_experience_training",
                gridSize: { xs: 12, md: 6 },
              },

              {
                mainheading: "Whistleblower Policies",
              },
              {
                question: "Existence",
                key: "whistleblowerPolicies.existence",
                gridSize: { xs: 12, sm: 6, md: 4 },
              },
              {
                question: "No of Reports ",
                key: "whistleblowerPolicies.reports",
                gridSize: { xs: 12, sm: 6, md: 4 },
              },
              {
                question: "Resolution",
                unit: "%",
                key: "whistleblowerPolicies.resolution",
                gridSize: { xs: 12, sm: 6, md: 4 },
              },

              {
                mainheading: "Compliance with Laws and Regulations",
              },
              {
                question: "Type of Compliance",
                key: "complianceLawsRegulations.type_compliance",
                gridSize: { xs: 12, sm: 6, md: 4 },
              },
              {
                question: "Frequency ",
                key: "complianceLawsRegulations.frequency",
                gridSize: { xs: 12, sm: 6, md: 4 },
              },
              {
                question: "Fine Paid",
                key: "complianceLawsRegulations.fine_paid",
                gridSize: { xs: 12, sm: 6, md: 4 },
              },
            ],
          },
          {
            title: "RISK MANAGEMENT",
            data: data?.riskMangement,
            url: "/governance/risk-management",
            questionary: [
              {
                question: "Enterprise Risk Management Framework",
                key: "enterpriseRiskMangementFramework.radio",
              },
              {
                question: "Scope",
                key: "enterpriseRiskMangementFramework.Scope",
              },

              {
                mainheading: "Identification and Mitigation of ESG Risks",
              },
              {
                question: "Description of ESG Risk",
                gridSize: { xs: 12, md: 6 },
                key: "indentificationMitigationEsgRisk.esg_risk",
              },
              {
                question: "Mitigation",
                gridSize: { xs: 12, md: 6 },
                key: "indentificationMitigationEsgRisk.mitigation",
              },

              {
                mainheading: "Incidence Response Plan",
              },
              {
                question: "Existence",
                gridSize: { xs: 12, md: 6 },
                key: "IncidenceResponsePlan.existence",
              },
              {
                question: "Effectiveness",
                gridSize: { xs: 12, md: 6 },
                key: "IncidenceResponsePlan.effectiveness",
              },
            ],
          },
          {
            title: "STAKEHOLDER ENGAGEMENT",
            data: data?.stakeholder,
            url: "/governance/stakeholder",
            questionary: [
              {
                question: "Stakeholder Identification and Engagement Processes",
                key: "stakeholderIdentificationEngagementProcesses.radio",
              },
              {
                question: "Scope",
                key: "stakeholderIdentificationEngagementProcesses.Scope",
              },
              { mainheading: "Identification and Mitigation of ESG Risks" },
              {
                question: "Description of ESG Risk",
                key: "indentificationMitigationEsgRisk.esg_risk",
                gridSize: { xs: 12, md: 6 },
              },
              {
                question: "Mitigation",
                key: "indentificationMitigationEsgRisk.mitigation",
                gridSize: { xs: 12, md: 6 },
              },
            ],
          },

          {
            title: "CYBERSECURITY & DATA PRIVACY",
            data: data?.cybersecurity,
            url: "/governance/cybersecurity",
            questionary: [
              { mainheading: "Cybersecurity Incidents" },
              {
                question: "High Risk",
                key: "cybersecurityIncidents.high",
                gridSize: { xs: 12, sm: 6, md: 3 },
              },
              {
                question: "Medium Risk",
                key: "cybersecurityIncidents.medium",
                gridSize: { xs: 12, sm: 6, md: 3 },
              },
              {
                question: "Low Risk",
                key: "cybersecurityIncidents.low",
                gridSize: { xs: 12, sm: 6, md: 3 },
              },
              {
                question: "Total",
                key: "cybersecurityIncidents.total",
                gridSize: { xs: 12, sm: 6, md: 3 },
              },

              { mainheading: "Data Privacy Breaches" },
              {
                question: "High Risk",
                key: "dataPrivacyBreaches.high",
                gridSize: { xs: 12, sm: 6, md: 3 },
              },
              {
                question: "Medium Risk",
                key: "dataPrivacyBreaches.medium",
                gridSize: { xs: 12, sm: 6, md: 3 },
              },
              {
                question: "Low Risk",
                key: "dataPrivacyBreaches.low",
                gridSize: { xs: 12, sm: 6, md: 3 },
              },
              {
                question: "Total",
                key: "dataPrivacyBreaches.total",
                gridSize: { xs: 12, sm: 6, md: 3 },
              },

              { mainheading: "Implementation of Cybersecurity Measures" },
              {
                question: "Policy",
                key: "implementationCybersecurityMeasure.radio",
              },
              {
                question: "Frequency of Training Programs (in a year)",
                key: "implementationCybersecurityMeasure.Scope",
              },
            ],
          },
        ];

        const sectionResults = [];

        for (const config of sectionConfigs) {
          sectionResults.push({
            title: config.title,
            questionary: config.questionary,
            columns: config.columns,
            url: config.url,
            data: config?.data || {},
          });
        }

        setSections(sectionResults);
      } catch (error) {
        console.error("Error fetching section data:", error);
      }
    };

    fetchData();
  }, [data]);

  return (
    <>
      <Typography
        sx={{
          color: "#1C486B",
          fontWeight: 600,
          fontSize: "20px",
          lineHeight: "24px",
          textTransform: "uppercase",
          fontFamily: "inter",
          mt: "1rem",
        }}
      >
        Baseline : Governance
      </Typography>
      {sections.map((section, index) => {
        const needsPageBreak = [1, 3, 5].includes(index);
        return (
          <React.Fragment key={index}>
            {needsPageBreak && (
              <>
                <PageBreak />
                <div style={{ marginTop: "1.3rem" }} />
              </>
            )}
            <MultiColumns
              title={section.title}
              questionary={section.questionary}
              columns={section.columns}
              data={section.data}
              url={section.url}
              isEditing={isEditing}
            />
          </React.Fragment>
        );
      })}
    </>
  );
};

export default Governance;
